import { LegendStates, MouseSelectionStates } from "types";

import { mpcCompatibleHoverLegends, mpcCompatibleSelectionParams } from "./mpcHighlights";

export function rateTimeHoverLegends(params: Partial<MouseSelectionStates>) {
  return mpcCompatibleHoverLegends(params);
}

export function rateTimeSelectionParams(params: Partial<LegendStates>) {
  return mpcCompatibleSelectionParams(params);
}
